/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tld: NonNullable<unknown> }} Tld_Pricing_Move_DownInputs */

const id_tld_pricing_move_down = /** @type {(inputs: Tld_Pricing_Move_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Turunkan ${i?.tld}`)
};

const en_tld_pricing_move_down = /** @type {(inputs: Tld_Pricing_Move_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move ${i?.tld} down`)
};

/**
* | output |
* | --- |
* | "Move {tld} down" |
*
* @param {Tld_Pricing_Move_DownInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_move_down = /** @type {((inputs: Tld_Pricing_Move_DownInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Move_DownInputs, { locale?: "id" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_move_down(inputs)
	return id_tld_pricing_move_down(inputs)
});